import React, { memo } from "react";
import { classNames } from "helpers";
import { ReactSVG } from "react-svg";

interface UserStepStatusBarProps {
  stepLabels: string[];
  stepCurrent: number;
  onStepClick?: (stepIndex: number) => void;
}

const UserStepStatusBar: React.FC<UserStepStatusBarProps> = ({
  stepLabels,
  stepCurrent,
  onStepClick,
}) => {
  return (
    <div className="w-50 flex border border-x-0 border-t-0 border-slate-200 overflow-hidden  ">
      {stepLabels.map((label, index) => {
        const isActive = index === stepCurrent;
        const isPast = index < stepCurrent;

        // Prošli korak je gotov (svijetlo zeleno s kvačicom), a trenutni je
        // "u tijeku" (svijetlo plavo).
        const isCompleted = isPast;
        const isInProgress = isActive;

        return (
          <button
            key={index}
            type="button"
            onClick={() => onStepClick?.(index)}
            className={classNames(
              "flex-1 flex items-center justify-center gap-2 py-2.5 px-3 text-sm border-r last:border-r-0 transition-all duration-200 cursor-pointer hover:opacity-80",
              isCompleted
                ? "bg-green-100 text-green-800 font-semibold border-b-2 border-b-green-600"
                : isInProgress
                  ? "bg-sky-50 text-sky-700 font-medium border-slate-200"
                  : "bg-white text-slate-400 font-medium border-slate-200"
            )}
          >
            {isCompleted && (
              <ReactSVG
                src="/media/icons/check.svg"
                className="w-4 h-4 stroke-green-700"
              />
            )}
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default memo(UserStepStatusBar);
